<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-11 08:48:07
-->
<template>
  <div class="add-danwei">
    <el-form ref="ruleForm"
             :model="viewData"
             label-width="100px">
             <el-form-item label="资源名称"
                    prop="first_word">
                    {{ viewData.resourceName }}
      </el-form-item>
      <el-form-item label="资源code"
                    prop="">
                    {{ viewData.resourceCode }}
      </el-form-item>
      <el-form-item label="资源分组"
                    prop="">
                    {{ viewData.resourceGroupName }}
      </el-form-item>
    </el-form>
    <div class="fix-fotter">
      <el-button style="min-width: 117px;background: #1067E0;font-size: 16px;border-color: #1067E0;"
                 size="mini"
                 type="primary"
                 @click="$emit('onUpdateDrawer', -1)">取消</el-button>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import fetch from "@/api/tianzheng/Qu";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
export default {
  data () {
    return {
      id:'',
      viewData:{}
    };
  },
  components: {
    Pagination,
  },
  created () {
  },
  mounted () {
  },
  methods: {
    initFun(obj){
      let that = this
      if (obj.id) {
        // 编辑
        this.id = obj.id;
        fetch.resourceDetail({id:this.id}).then((res) => {
          that.viewData = res.result
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  min-height: calc(100vh - 98px);
}
</style>
